import AuthService from "./AuthService";
//const API_URL = "http://localhost:8081/api/doctor/";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/doctor/`;
class DoctorService {
  async getAll() {
    try {
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Server nije vratio JSON odgovor");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching doctors:", error);
      throw error;
    }
  }

  async getById(id) {
    try {
      const response = await fetch(API_URL + id, {
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Server nije vratio JSON odgovor");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching doctor by ID:", error);
      throw error;
    }
  }

  async create(doctor) {
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
        body: JSON.stringify(doctor),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Server nije vratio JSON odgovor");
      }

      return await response.json();
    } catch (error) {
      console.error("Error creating doctor:", error);
      throw error;
    }
  }

async createUser(user) {
  try {
    const response = await fetch(`${API_URL}user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
      body: JSON.stringify(user),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
    }

    const contentType = response.headers.get("Content-Type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Server nije vratio JSON odgovor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
}


  async update(id, doctor) {
    try {
      const response = await fetch(API_URL + id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
        body: JSON.stringify(doctor),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Server nije vratio JSON odgovor");
      }

      return await response.json();
    } catch (error) {
      console.error("Error updating doctor:", error);
      throw error;
    }
  }
  getDoctorById(id) {
    return fetch(`${API_URL}${id}`, {
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    }).then(async (res) => {
      if (!res.ok) throw new Error(`Greška: ${res.status}`);
      return res.json();
    });
  }
  async getUserByDoctorId(doctorId) {
  return fetch(`${API_URL}user/doctor/${doctorId}`, {
    headers: {
      "Content-Type": "application/json",
      ...AuthService.getAuthHeader(),
    },
  }).then(async (res) => {
    if (!res.ok) throw new Error(`Greška: ${res.status}`);
    return res.json();
  });
}
async updateUser(userId, userData) {
  return fetch(`${API_URL}user/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...AuthService.getAuthHeader(),
    },
    body: JSON.stringify(userData),
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Greška: ${res.status} - ${text}`);
    }
    return res.json();
  });
 
}


  async delete(id) {
    try {
      const response = await fetch(API_URL + id, {
        method: "DELETE",
        headers: AuthService.getAuthHeader(),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Server nije vratio JSON odgovor");
      }

      return await response.json();
    } catch (error) {
      console.error("Error deleting doctor:", error);
      throw error;
    }
  }
}

export default new DoctorService();